<template>
  <v-row class="investsstatistics pa-0 ma-0 justify-center">
    <v-col
      :cols="!$vuetify.breakpoint.mobile ? 4 : 12"
      justify="center"
      align="center"
    >
      <v-row class="content">
        <v-col cols="12" class="description"
          >Volume médio mensal de embalagens comercializadas</v-col
        >
        <v-col class="data-details" cols="12">67,13</v-col>
        <v-col class="ma-0 pa-0">toneladas</v-col>
      </v-row>
    </v-col>
    <v-col
      :cols="!$vuetify.breakpoint.mobile ? 4 : 12"
      justify="center"
      align="center"
    >
      <v-row class="content">
        <v-col cols="12" class="description"
          >Volume total a ser compensado</v-col
        >
        <v-col class="data-details" cols="12">14,77</v-col>
        <v-col class="ma-0 pa-0">toneladas</v-col>
      </v-row>
    </v-col>
    <v-col
      :cols="!$vuetify.breakpoint.mobile ? 4 : 12"
      justify="center"
      align="center"
    >
      <v-row class="content">
        <v-col class="description">Percentual do plano de compensação</v-col>
        <v-col class="data-details" cols="12">100% </v-col>
      </v-row>
    </v-col>
    <v-col
      :cols="!$vuetify.breakpoint.mobile ? 4 : 12"
      justify="center"
      align="center"
    >
      <v-row class="content">
        <v-col class="description">Material compensado</v-col>
        <v-col class="data-details" cols="12">Papel</v-col>
      </v-row>
    </v-col>
    <v-col
      :cols="!$vuetify.breakpoint.mobile ? 4 : 12"
      justify="center"
      align="center"
    >
      <v-row class="content">
        <v-col class="description">Nº de Estados impactados</v-col>
        <v-col class="data-details" cols="12">20</v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'InvestsStatistics',
};
</script>

<style lang="sass" scoped>
.investsstatistics
  .content
    background: #fff
    margin: 8px
    padding: 16px
    border-radius: 16px
    box-shadow: 0px 5px 12px #e8e8e8
    min-height: 170px

  .data-details
    color: #01ee55
    font-size: 2em
  .description
    padding: 0
    font-size: 16px

  .chart
    .legend
      font-size: 14px

    .colorbox
      display: inline-block
      width: 10px
      height: 10px

    .chartpie
      width: 100%
      height: 200px

.new-color
  .investsstatistics
    .data-details
      color: #26d07c
</style>
